import React from "react";
import { createRoot } from "react-dom/client";
import Astrology from "./Astrology";

export function mount(element) {
  if (!element || element.dataset.mounted === "true") return;
  const data = JSON.parse(element.dataset.astrology);
  element.dataset.mounted = "true";
  createRoot(element).render(<Astrology data={data} />);
}

function mountAll() {
  document.querySelectorAll("#astrology").forEach(mount);
}

document.addEventListener("DOMContentLoaded", mountAll);
document.addEventListener("turbo:load", mountAll);
